/**
 * Presentation helpers for BAA request statuses, shared by the dashboard list
 * and detail views (kept pure for unit testing).
 */

export const STATUS_LABELS = {
  pending: "Pending",
  sent_for_signature: "Sent for signature",
  institution_signed: "Institution signed",
  fully_executed: "Fully executed",
  declined: "Declined",
  expired: "Expired",
};

/** MUI Chip color per status. */
export const STATUS_CHIP_COLOR = {
  pending: "warning",
  sent_for_signature: "info",
  institution_signed: "info",
  fully_executed: "success",
  declined: "default",
  expired: "default",
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || "Unknown";
}

export function statusColor(status) {
  return STATUS_CHIP_COLOR[status] || "default";
}

/** Filter tabs across the top of the list view. */
export const FILTER_TABS = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "in_progress", label: "In Progress" },
  { key: "executed", label: "Executed" },
];

/**
 * Whether a request with `status` belongs in the given filter tab.
 * @param {string} status
 * @param {string} tabKey
 * @returns {boolean}
 */
export function matchesFilter(status, tabKey) {
  switch (tabKey) {
    case "pending":
      return status === "pending";
    case "in_progress":
      return status === "sent_for_signature" || status === "institution_signed";
    case "executed":
      return status === "fully_executed";
    case "all":
    default:
      return true;
  }
}

/**
 * Count of requests in each filter tab.
 * @param {object[]} requests
 * @returns {Record<string, number>}
 */
export function countByFilter(requests) {
  return FILTER_TABS.reduce((acc, tab) => {
    acc[tab.key] = requests.filter((r) => matchesFilter(r.status, tab.key))
      .length;
    return acc;
  }, {});
}
